module.exports = __webpack_public_path__ + "img/ic_user.8f4ec08c.svg";